import styled from 'styled-components'

import { colours } from '../../_globals/theme'

const Container = styled.section`
  display: block;
  position: relative;
  width: 100%;
  max-width: 1000px;
  height: ${props => props.theme.height};
  padding-left: ${props => props.theme.paddingLeft};
  padding-top: ${props => props.theme.paddingTop};
  padding-right: ${props => props.theme.paddingRight};
  padding-bottom: ${props => props.theme.paddingBottom};
  margin-left: auto;
  margin-top: ${props => props.theme.marginTop};
  margin-right: auto;
  margin-bottom: ${props => props.theme.marginBottom};
  background-color: transparent;

  &::before {
    content: '';
    background-color: ${props => props.theme.background};
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: -1;
  }
`
Container.defaultProps = {
  theme: {
    width: '100%',
    height: 'auto',
    paddingLeft: '0px',
    paddingTop: '0px',
    paddingRight: '0px',
    paddingBottom: '0px',
    marginLeft: '0px',
    marginTop: '0px',
    marginRight: '0px',
    marginBottom: '0px',
    background: colours.lightGrey,
  },
}

const AlertContainer = styled.div`
  max-width: 80%;
  margin: 20px auto;
`

const Logo = styled.img`
  display: block;
  margin: auto;
  width: 100%;
  max-width: 800px;
`

export { Container, AlertContainer, Logo }
